<template>
    <div class="datePicker">
        <label style="color:var(--darkgray)">{{ label }}:</label>
        <date-picker :disabled-date="notAfterTodayDisabled" :shortcuts="shortcutsObjects" format="DD/MM/YYYY" @change="handleChange" value-type="YYYY-MM-DD" range-separator=" até " v-model="date" range></date-picker>
    </div>
</template>
<script>
  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/index.css'
  import 'vue2-datepicker/locale/pt-br'

  export default {
    name: 'DateRange',
    components: { DatePicker },
    props: {
      value: [String, Date, Array],
      label: { type: String, default: 'Data:' },
      shortcut: { type: Boolean, default: false },
      notAfterTodayHabilitado: { type: Boolean, default: false }
    },
    data: () => ({
      shortcutsObjects: [
        { text: `Hoje`,
          onClick: () => {
            return [new Date(), new Date()]
          }
        },
        { text: `Ontem`,
          onClick: () => {
            const yesterday = new Date()
            yesterday.setDate(yesterday.getDate() - 1)
            return [yesterday, yesterday]
          }
        },
        {
          text: `Esta semana`,
          onClick: () => {
            const today = new Date()
            const dayOfWeek = today.getDay()
            const startOfWeek = new Date(today)
            startOfWeek.setDate(today.getDate() - dayOfWeek)
            const endOfWeek = new Date(today)
            endOfWeek.setDate(today.getDate() + (6 - dayOfWeek))
            return [startOfWeek, endOfWeek]
          }
        },
        {
          text: `Semana anterior`,
          onClick: () => {
            const today = new Date()
            const dayOfWeek = today.getDay()
            const startOfLastWeek = new Date(today)
            startOfLastWeek.setDate(today.getDate() - dayOfWeek - 7)
            const endOfLastWeek = new Date(today)
            endOfLastWeek.setDate(today.getDate() - dayOfWeek - 1)
            return [startOfLastWeek, endOfLastWeek]
          }
        },
        { text: `Este mês`,
          onClick: () => {
            const today = new Date()
            const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
            const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0)
            return [firstDayOfMonth, lastDayOfMonth]
          }
        },
        { text: `Mês passado`,
          onClick: () => {
            const today = new Date()
            const firstDayOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1)
            const lastDayOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0)
            return [firstDayOfLastMonth, lastDayOfLastMonth]
          }
        },
        { text: `Este Ano`,
          onClick: () => {
            const today = new Date()
            const firstDayOfYear = new Date(today.getFullYear(), 0, 1)
            const lastDayOfYear = new Date(today.getFullYear(), 11, 31)
            return [firstDayOfYear, lastDayOfYear]
          }
        },
        { text: `Ano passado`,
          onClick: () => {
            const today = new Date()
            const firstDayOfLastYear = new Date(today.getFullYear() - 1, 0, 1)
            const lastDayOfLastYear = new Date(today.getFullYear() - 1, 11, 31)
            return [firstDayOfLastYear, lastDayOfLastYear]
          }
        }
      ]
    }),
    computed: {
      date: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    },
    methods: {
      // Se o tipo for indefinido, se usou um atalho!
      handleChange (value, type) {
        if (type === undefined) {
          this.$emit('filter')
        }
      },
      notAfterToday (date) {
        return date > new Date(new Date().setHours(0, 0, 0, 0))
      },
      notAfterTodayDisabled (date) {
        if (!this.notAfterTodayHabilitado) {
          return false
        }
        return date > new Date(new Date().setHours(0, 0, 0, 0))
      }
    }
  }
</script>

<style lang="scss">
.datePicker{
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
    label{
        margin-top:5px;
        margin-bottom: 8px;
        font-size: 13px;
    }
    .mx-datepicker{
        max-width: 100%;
        width: 100%;
    }
    .mx-datepicker.mx-datepicker-range{
        .mx-input-wrapper{
            input{
                padding:22px 12px 22px 12px;
                color: var(--dark);
                -webkit-box-flex: 1;
                -ms-flex: 1 1 auto;
                flex: 1 1 auto;
                line-height: 20px;
                max-width: 100%;
                min-width: 0px;
                width: 100%;
                border-radius: 10px;
            }
        }
    }
}
</style>

<style>

.mx-datepicker-sidebar{
    width: 120px;
}
.mx-datepicker-content{
    margin-left:120px !important;
}
.mx-datepicker-main.mx-datepicker-popup .mx-datepicker-sidebar button {
    overflow-wrap: break-word !important;
    width:115px !important;
    white-space: pre-line;
    margin-bottom: 10px;
}
</style>
